import { Module } from 'vuex';
import { RootState } from '../types';
import { createActions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { ReportState } from './types';

export const state: ReportState = {
  data: null
};

export function create(): Module<ReportState, RootState> {
  const actions = createActions();
  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
}

export const name = 'reportModule';
